/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Rag_Priority_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "The AI no longer prioritises internal sources and may again favour its general training data." |
*
* @param {Audit_Details_Rag_Priority_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_rag_priority_disabled_desc = /** @type {((inputs?: Audit_Details_Rag_Priority_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Rag_Priority_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die KI priorisiert keine internen Quellen mehr und kann erneut auf ihr allgemeines Trainingswissen zurückgreifen.")
	return /** @type {LocalizedString} */ ("The AI no longer prioritises internal sources and may again favour its general training data.")
});